/**
 * partnerBulkAssign.js — админская bulk-привязка партнёров к менеджеру по fi-коду.
 *
 * Вынесено из partnerCrm.js: тот упёрся в baseline размера файла (гейт
 * check_component_size), а привязка — самостоятельная область. Её правило
 * одно и жёсткое: менеджер берётся из ответа сервера, не из памяти.
 * Пустое состояние лидерборда держало фамилию живого сотрудника и его код
 * значениями по умолчанию (#5837), и форма этими значениями привязывала
 * партнёров к человеку по нажатию не глядя.
 */
import { apiFetch } from './core'

const BASE = '/partner-crm'

export const partnerBulkAssign = {
    // Кого предлагать: тот же разрез, что кормит лидерборд менеджеров, плюс
    // fi-код каждого — по памяти не набирается ни имя, ни код.
    managerCandidates: () => apiFetch(`${BASE}/admin/manager-candidates`),
    // Привязка по КЛЮЧУ менеджера из списка выше. Подстрока ФИО осталась
    // путём консольного скрипта, и ручка его по-прежнему понимает.
    assign: (managerId, refCode, apply = true) =>
        apiFetch(`${BASE}/admin/assign-partners-to-manager`, {
            method: 'POST',
            body: JSON.stringify({
                manager_id: managerId,
                ref_code: refCode,
                apply,
            }),
        }),
}
